/**
 * 菜单功能按钮的国际化
 * date：2022 04 25
 */
export default {
  func: {
    viewIncubator: 'View Incubator',
    newIncubator: 'New Incubator',
    editIncubator: 'Edit Incubator',
    relatedIncubator: 'Device Associated to Incubator',
    removeIncubator: 'Delete Incubator',
    viewIncubatorOperate: 'View Incubator Operation Records',
    removeIncubatorOperate: 'Delete Incubator Operation Records',
    viewIncubatorCollect: 'View Incubator Sampling Settings',
    applyIncubatorCollect: 'Apply Incubator Data Sampling Settings',
    removeIncubatorCollect: 'Delete Incubator Sampling Settings',
    viewFridge: 'View Refrigerators',
    newFridge: 'New Refrigerator',
    editFridge: 'Edit Refrigerator',
    relatedFridge: 'Device Associated to Refrigerator',
    removeFridge: 'Delete Refrigerator',
    viewFridgeOperate: 'View Refrigerator Operation Records',
    removeFridgeOperate: 'Delete Refrigerator Operation Records',
    viewFridgeCollect: 'View Refrigerator  Sampling Settings',
    applyFridgeCollect: 'Apply Refrigerator Data Sampling Settings',
    removeFridgeCollect: 'Delete Refrigerator Sampling Settings',
    viewCar: 'View Vehicles',
    newCar: 'New Vehicle',
    editCar: 'Edit Vehicle Info.',
    relatedCar: 'Device Associated to Vehicle',
    removeCar: 'Delete Vehicle',
    viewCarOperate: 'View Vehicle Operation Records',
    removeCarOperate: 'Delete Vehicle Operation Records',
    viewCarCollect: 'View Vehicle Sampling Settings',
    applyCarCollect: 'Apply Vehicle Data Sampling Settings',
    removeCarCollect: 'Delete Vehicle Sampling Settings',
    viewRefrigeratory: 'View Cold Storage',
    newRefrigeratory: 'New Cold Storage',
    editRefrigeratory: 'Edit Cold Storage',
    relatedRefrigeratory: 'Device Associated to Cold  Storage',
    removeRefrigeratory: 'Delete Cold Storge',
    viewRefrigeratoryOperate: 'View Cold Storage Operation Records',
    removeRefrigeratoryOperate: 'Delete Cold Storge Operation Records',
    viewRefrigeratoryCollect: 'View Cold Storage Sampling Settings',
    applyRefrigeratoryCollect: 'Apply Cold Storage Sampling Settings',
    removeRefrigeratoryCollect: 'Delete Cold Storge Sampling Settings',
    viewEx: 'View Abnormal Records',
    handleEx: 'Handle Abnormal Records',
    viewExReason: 'View Abnormal Causes',
    newExReason: 'New Abnormal Cause',
    editExReason: 'Edit Abnormal Causes',
    removeExReason: 'Delete Abnormal Causes',
    viewCustomer: 'View Customers',
    newCustomer: 'New Customer',
    editCustomer: 'Edit Customer',
    removeCustomer: 'Delete Customer',
    viewRole: 'View Roles',
    newRole: 'New Role',
    editRole: 'Edit Role',
    removeRole: 'Delete Role',
    viewUser: 'View User',
    newUser: 'New User',
    editUser: 'Edit User',
    removeUser: 'Delete User',
    viewVoiceNoticeLog: 'View Voice Notifications',
    viewMessageNoticeLog: 'View SMS  Notifications',
    viewEmailNoticeLog: 'View Email Notifications',
    removeVoiceNoticeLog: 'Delete Voice Notifications',
    removeMessageNoticeLog: 'Delete SMS Notifications',
    removeEmailNoticeLog: 'Delete Email Notifications',
    viewScene: 'View Organization',
    modifyScene: 'Edit Organization',
    viewProbeUnit: 'View Measurement Units',
    newProbeUnit: 'New Measurement Unit',
    editProbeUnit: 'Edit Measurement Unit',
    deleteProbeUnit: 'Delete Measurement Unit',
    viewParam: 'View Parameters',
    newParam: 'New Parameter',
    editParam: 'Edit Parameters',
    deleteParam: 'Delete Parameter Type',
    viewProbeRange: 'View Monitoring Ranges',
    newProbeRange: 'New Range',
    deleteProbeRange: 'Delete Monitoring Range',
    viewForwardSet: 'View Forwarding Settings',
    newForwardSet: 'New Forwarding Settings',
    editForwardSet: 'Edit Forwarding Settings',
    deleteForwardSet: 'Delete Forwarding Setting',
    viewUrlPage: 'View Resource',
    newUrlPage: 'New Resource',
    editUrlPage: 'Edit Resource',
    deleteUrlPage: 'Delete Resource',
    viewRecordPoint: 'View Readings',
    exportRecordPoint: 'Export Readings',
    editRecordPoint: 'Edit Readings',
    deleteRecordPoint: ' delete asset record point',
    viewCarrierRecordSet: ' view asset record point setting',
    editCarrierRecordSet: 'Edit  Asset Reading Settings',
    viewSysLog: 'View System Log',
    deleteSysLog: 'Delete System Log',
    setSysLog: 'System Log Trigger Settings',
    viewContacts: 'View Contacts',
    newContacts: 'New Recipient',
    editContacts: 'Edit Contacts',
    deleteContacts: 'Delete Contacts',
    contactsSync: 'Sync Contacts',
    viewDisplay: 'View Displays',
    applyDisplayAppConfig: 'Configure Display Parameters',
    applyDisplayNetConfig: 'Configure Display Network Parameters',
    viewDisplayAppConfig: 'View Display Parameters',
    viewDisplayNetConfig: 'View Display Network',
    removeDisplayConfigLog: 'Delete Display Configuration Records',
    editDisplay: 'Edit Display',
    newDisplay: 'New Display',
    removeDisplay: 'Delete Display',
    viewDisplayConfigLog: 'View Display Config. Records',
    viewGateway: 'View Gateway',
    editGateway: 'Edit Gateway',
    applyGatewayNetConfig: 'save gateway net configure ',
    viewGatewayNetConfig: 'view gateway net configure ',
    viewGatewayConfigLog: 'View Gateway Configuration Records',
    removeGatewayConfigLog: 'Delete Gateway Configuration Records',
    newGateway: 'New Gateway',
    viewGatewayHeartbreak: 'View Gateway Heartbeat Records',
    removeGateway: 'Delete Gateway',
    viewSensor: 'View Sensors',
    editSensor: 'Edit Sensor',
    applySensorAppConfig: 'Configure Sensor Parameters',
    applySensorNetConfig: 'Configure Sensor Network Parameters',
    applySensorAlarmConfig: 'Configure Sensor Alarm Parameters',
    applySensorGpsConfig: 'Configure Sensor GPS Parameters',
    viewSensorAppConfig: 'View Sensor Settings',
    viewSensorNetConfig: 'Viewt Sensor Network Settings',
    viewSensorConfigLog: 'View Sensor Configuration Records',
    removeSensorConfigLog: 'Delete Sensor Configuration Records',
    newSensor: 'New Sensor',
    removeSensor: 'Delete Sensor',
    viewAlarmTrigger: 'View Alarm Triggers',
    newAlarmTrigger: 'New Alarm Trigger',
    editAlarmTrigger: 'Edit Alarm Trigger',
    deleteAlarmTrigger: 'Delete Alarm Trigger',
    viewRelay: 'View Repeaters',
    editRelay: 'Edit Repeater',
    applyRelayNetConfig: 'Configure Repeater Network Parameters',
    viewRelayNetConfig: 'View Repeater Network Settings',
    viewRelayConfigLog: 'View Repeater Configuration Records',
    removeRelayConfigLog: 'Delete Repeater Configuration Records',
    newRelay: 'New Repeater',
    removeRrelay: 'Delete Repeater',
    viewDetectionTask: 'View Detection Tasks',
    editDetectionTask: 'Edit Detection Task',
    newDetectionTask: 'New Detection Task',
    deleteDetectionTask: 'Delete Detection Task',
    triggerDetectionTask: 'Trigger Detection Task',
    editProbeRange: 'Edit Monitoring Range',
    viewCarrierType: 'View Asset Types',
    newCarrierType: 'New Asset Type',
    editCarrierType: 'Edit Asset Type',
    removeCarrierType: 'Delete Asset Type',
    viewDeviceRealTime: 'view device monitor ',
    newDeviceRealTime: 'New Device Real-time Status',
    viewDeviceType: 'View Device Types',
    newDeviceType: 'New Device Type',
    editDeviceType: 'edit device type ',
    removeDeviceType: 'delete device type ',
    editRecordPointSet: 'Edit  Asset Reading Settings',
    viewMonitorPointRealTime: 'view asset monitor ',
    saveMonitorPointRealTime: 'Save Real-time Status of Asset',
    viewDeviceDataAnalyse: 'View Device Data Analysis',
    saveDeviceDataAnalyse: 'Save Data Analysis',
    viewMonitorAnalysis: 'View Asset Data Analysis',
    saveMonitorAnalysis: 'Save Real-time Status of Asset',
    viewMapTrack: 'View Map',
    viewDownloadRecord: 'View Download Records',
    deleteDownloadRecord: 'Delete Download Record',
    viewDetailData: 'View Data Details',
    viewAlarmRecord: 'View Alarm Records',
    deleteAlarmRecord: 'Delete  Alarm Record',
    viewWorkOrder: 'View Work Order',
    addWorkOrder: 'New Work Order',
    editWorkOrder: 'Edit Work Order',
    deleteWorkOrder: 'Delete Work Order',
    viewWorkSet: 'View Work Order Settings',
    viewAlarmSwitchLog: 'View Alarm Toggle Log',
    editAlarmSwitchLog: 'Edit Alarm Toggle Records',
    deleteAlarmSwitchLog: 'Delete Alarm Toggle Record',
    viewPlinth: 'View Smart Bracket',
    newPlinth: 'New Smart Bracket',
    editPlinth: 'Edit Smart Bracket',
    removePlinth: 'Delete Smart Bracket',
    viewPlinthBind: 'View Associated Brackets',
    editPlinthBind: 'Bind Bracket',
    removeEx: 'Delete Abnormal Records',
    viewBorrow: 'View Device Loan',
    removeBorrow: 'Release from Loan',
    viewWarehouse: 'View Warehouse',
    newWarehouse: 'New Warehouse',
    editWarehouse: 'Edit Warehouse',
    relatedWarehouse: 'Device Associated to Warehouse',
    removeWarehouse: 'Delete Warehouse',
    viewWarehouseOperate: 'View Warehouse Operation Records',
    removeWarehouseOperate: 'Delete Warehouse  Operation Records',
    viewWarehouseCollect: 'View Warehouse Sampling Settings',
    applyWarehouseCollect: 'Apply Warehouse Data Sampling Settings',
    removeWarehouseCollect: 'Delete Warehouse Sampling Settings',
    viewStore: 'View Store',
    newStore: 'New Store',
    editStore: 'Edit Store',
    relatedStore: 'Device Associated to Store',
    removeStore: 'Delete Store',
    viewStoreOperate: 'View Store Operation Records',
    removeStoreOperate: 'Delete Store Operation Records',
    viewStoreCollect: 'View Store Sampling Settings',
    applyStoreCollect: 'Apply Store Data Sampling Settings',
    removeStoreCollect: 'Delete Store Sampling Settings',
    applyGatewayAndroidNetConfig: 'save gateway2.0 net configure ',
    viewGatewayAndroidNetConfig: 'view gateway2.0 net configure ',
    applyGatewayAlarmNetConfig: 'save gateway2.0 alarm configure ',
    viewGatewayAlarmNetConfig: 'view gateway2.0 alarm configure ',
    viewGas: 'View Gas Sensor',
    editGas: 'Edit Gas Sensor',
    newGas: 'New Gas Sensor',
    removeGas: 'Delete Gas Sensor',
    viewGasConfigLog: 'View Gas Sensor Config. Records',
    removeGasConfigLog: 'Delete Gas Sensor Configration Records',
    applyGasAppConfig: 'save gas app configure ',
    viewGasAppConfig: 'view gas app configure ',
    viewSensorCalibration: 'View Sensor Calibration Info.',
    saveSensorCalibration: 'Configure Sensor Calibration',
    viewGasCalibration: 'View Gas Calibration',
    saveGasCalibration: 'Configure Gas Calibration',
    viewMagnetismCalibration: 'View Door Sensor Calibration',
    saveMagnetismCalibration: 'Save Door Sensor Calibration',
    viewMagentism: 'View Door Sensors',
    editMagentism: 'edit magnetism ',
    newMagentism: 'New Door Sensor',
    removeMagentism: 'Delete Door Sensor',
    viewMagentismConfigLog: 'View Door Sensor Config. Records',
    removeMagentismConfigLog: 'Delete Door Sensor Configration Records',
    applyMagentismAppConfig: 'Configure Door Sensor Parameters',
    viewMagentismAppConfig: 'view magnetism app configure ',
    viewExportTask: 'View Export Task',
    addExportTask: 'New Export Task',
    updateExportTask: 'Update Export Task',
    removeExportTask: 'Delete Export Task',
    viewExportTaskHis: 'View Export Records',
    removeExportTaskHis: 'Delete Export History',
    viewOverviewDevice: 'View Device Overview',
    viewOverviewCarrier: 'View Asset Overview',
    viewOverviewAlarm: 'View Alarm Overview',
    viewOverviewEx: 'View Abnormal Overview',
    viewDataStatistics: 'View Data Statistics',
    saveDataStatistics: 'Save Data Statistics',
    eportDataStatistics: 'Export Data Statistics',
    viewVerifyTask: 'View Verification Tasks',
    addVerifyTask: 'New Validation Task',
    updateVerifyTask: 'Update Validation Task',
    removeVerifyTask: 'Delete Verification Task',
    viewVerifyTaskHis: 'View Verification Records',
    removeVerifyTaskHis: 'Delete Verification Task History',
    downloadVerifyTask: 'Download Verification Task',
    viewExRule: 'View Invalid Rules',
    newExRule: 'New Abnormal Exclusion Rule',
    updateExRule: 'Update Invalid Rule',
    removeExRule: 'Delete Abnormal Exclusion Rule',
    saveMagentismCalibration: 'Save Door Sensor Calibration',
  }
}
